import script from "./growth-dashboard2.vue?vue&type=script&setup=true&lang=js"
export * from "./growth-dashboard2.vue?vue&type=script&setup=true&lang=js"

import "./growth-dashboard2.vue?vue&type=style&index=0&id=045ac908&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-045ac908"]])

export default __exports__